import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

/**
 * Yuklanish o'rni.
 *
 * "Nafas" (`animate-pulse`) o'rniga chapdan o'ngga o'tadigan yorug'lik: pulsatsiya butun
 * ekranni bir vaqtda o'chirib-yoqadi va bir nechta skelet birga turganda ekran miltillayotganday
 * ko'rinadi. O'tuvchi yorug'lik esa yo'nalishga ega — u o'qish yo'nalishi bilan bir xil tomonga
 * yuradi va "javob kelmoqda" degan ma'noni beradi.
 */
function Skeleton({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('bg-accent motion-shimmer rounded-md', className)}
      {...props}
    />
  );
}

export { Skeleton };
